"use client";

import { useSyncExternalStore } from "react";

/**
 * A cheap client-only guess at whether the visitor is signed in,
 * without mounting Clerk. Reads Clerk's `__client_uat` cookie — a
 * non-httpOnly cookie Clerk itself sets to the Unix timestamp of the
 * last client update ("0" or absent when signed out). This is a
 * presence *hint*, not a session check: it can be stale or spoofed,
 * so it must only ever gate which link/button label to show, never
 * anything that needs real auth (that's what Clerk in the
 * dashboard/auth/admin trees is for).
 *
 * No `subscribe` is wired to cookie changes (cookies don't emit
 * events) — a sign-in/out during the session updates on the next
 * navigation, which is fine for a marketing header CTA.
 */
const CLIENT_UAT_RE = /(?:^|;\s*)__client_uat=([^;]*)/;

function getSnapshot(): boolean {
  if (typeof document === "undefined") return false;
  const match = CLIENT_UAT_RE.exec(document.cookie);
  return !!match && match[1] !== "0" && match[1] !== "";
}

function getServerSnapshot(): boolean {
  return false;
}

function noop() {
  /* cookies don't emit change events — nothing to unsubscribe */
}

function subscribe(): () => void {
  return noop;
}

export function useSignedInHint(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
